"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnifiedSkeleton = void 0;
var _mui = require("@ori-ui/mui");
const UnifiedSkeleton = exports.UnifiedSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'none'
});
